module.exports = __webpack_public_path__ + "static/media/22x28no2.82b50484.jpg";